import {
  ComparisonGrowth,
  ComparisonPeriod,
  FactVolumeWithPeriod,
  TimeFrame,
  TimePeriod,
} from '@services/FiltersTypes';
import { Action, InitialFiltersTypes } from '@state/actions/Type';

export interface InitialFiltersState {
  initialFilters: InitialFilter[];
}

export interface InitialFilter {
  comparisonGrowth: ComparisonGrowth;
  comparisonPeriod: ComparisonPeriod;
  country: string;
  timeFrame: TimeFrame;
  timePeriod: TimePeriod;
  timePeriodV2: TimePeriod;
  isChannelFilterAllowed?: boolean;
  factVolumeWithPeriod: FactVolumeWithPeriod[];
  disabledV3AndV4ForSpecialConfig?: boolean;
}

export const getInitialState = () => {
  return Object.freeze({
    initialFilters: [
      {
        comparisonGrowth: {
          actual: 'Actual',
          percentage: 'Percentage',
        },
        comparisonPeriod: {
          samePeriodLastYear: 'vs Same period last year',
          previousPeriod: 'vs Previous period',
        },
        country: '',
        timeFrame: {
          weekly: null,
          monthly: null,
          rollingQuarter: null,
          calendarQuarter: null,
          customMonths: null,
          customWeeks: null,
        },
        timePeriod: {
          weekly: [],
          monthly: [],
          rollingQuarter: [],
          calendarQuarter: [],
          customMonths: [],
          customWeeks: [],
        },
        timePeriodV2: {
          weekly: [],
          monthly: [],
          rollingQuarter: [],
          calendarQuarter: [],
          customMonths: [],
          customWeeks: [],
        },
        isChannelFilterAllowed: false,
        factVolumeWithPeriod: [],
      },
    ],
  });
};
const InitialFiltersReducer = (
  state: InitialFiltersState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
): InitialFiltersState => {
  if (action.type === InitialFiltersTypes.InitialFiltersUpdate) {
    return {
      ...state,
      initialFilters: action.payload.initialFilters,
    };
  }
  return state;
};

export default InitialFiltersReducer;
